import { ReactNode } from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

import {
    ContentBlock,
    OneLinkProps
} from "@/components/wpl/content-block/src/content-block";
import {
    TabGroup,
    IndividualTabPropsCustom,
    TabColorProps
} from "@/components/wpl/tab-group/src/tab-group";
import { Link } from "@/libraries/design/components";
import { ProductKeyTypes } from "@/libraries/wpl/foundations/src/data-event-props";
import { Row } from "@/libraries/wpl/foundations/src/grid";
import {
    BGProps,
    StyledBackground
} from "@/libraries/wpl/foundations/src/styled-backgrounds";

export interface PatternTabsCustomProps {
    id: string;
    label: string;
    headerText: string;
    bodyText: string;
    tabs: IndividualTabPropsCustom[];
    dataProductKey: ProductKeyTypes;
    colors?: TabColorProps;
    ctaProps?: OneLinkProps;
    linkPosition?: "top" | "bottom";
    backgroundProperties?: BGProps;
    className?: string;
    banner?: ReactNode;
}

const CustomTabsStyle = css({
    padding: `${token("space.800")} 0`,
    [media.only.sm]: {
        padding: `${token("space.600")} 0`
    },
    [media.below.sm]: {
        padding: `${token("space.400")} 0`
    }
});

export const TabsCustom = ({
    id,
    label,
    headerText,
    bodyText,
    tabs,
    dataProductKey,
    colors,
    ctaProps,
    linkPosition = "bottom",
    backgroundProperties,
    className,
    banner
}: PatternTabsCustomProps) => {
    return (
        <StyledBackground {...backgroundProperties}>
            <div className={className} css={CustomTabsStyle}>
                <Row>
                    <ContentBlock
                        headerText={headerText}
                        headerType="h2"
                        bodyText={bodyText}
                        isCentered={true}
                        ctaProps={
                            linkPosition === "top" && ctaProps?.primaryLinkProps
                                ? ctaProps
                                : {}
                        }
                    />
                </Row>

                <div>
                    <TabGroup
                        colors={colors}
                        tabContentType="custom"
                        tabs={tabs}
                        id={id}
                        label={label}
                        dataProductKey={dataProductKey}
                        banner={banner}
                    />
                </div>

                {linkPosition === "bottom" && ctaProps?.primaryLinkProps ? (
                    <Row>
                        <div css={css({ textAlign: "center" })}>
                            <Link
                                {...ctaProps.primaryLinkProps}
                                text={ctaProps.primaryLinkProps.text}
                                aria-label={ctaProps.primaryLinkProps.text}
                            />
                        </div>
                    </Row>
                ) : null}
            </div>
        </StyledBackground>
    );
};
